<!-- FIN-0106: Circle-First Design Language - profile button -->
<div id="login_menu" class="p-1.5 select-none"
     *ngIf="getUserInfo() | async as userInfo">
  <div id="login_menu_visible_container"
       class="relative" (click)="toggleLoginDropdown()" (clickOutside)="handleClickOutsideLogin()">
    <!-- Profile button - pill shape with 120Hz optimized transitions -->
    <div class="cursor-pointer flex items-center gap-2 px-2 py-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 active:bg-gray-200 dark:active:bg-gray-700 active:scale-95 transition-all duration-fast ease-snap will-change-transform"
         [class.bg-gray-100]="isLoginDropdownVisible"
         [class.dark:bg-gray-800]="isLoginDropdownVisible">
      <!-- FIN-0106: Avatar - full circle for Circle-First design -->
      <img *ngIf="!isDataUrl(getSafeProfilePictureUrl(userInfo.profilePictureUrl, userInfo.givenName))"
           [ngSrc]="getSafeProfilePictureUrl(userInfo.profilePictureUrl, userInfo.givenName)"
           (error)="onImageError($event, userInfo.profilePictureUrl, userInfo.givenName)"
           alt="Profile picture"
           height="28"
           width="28"
           class="rounded-avatar"
           referrerpolicy="no-referrer"/>
      <img *ngIf="isDataUrl(getSafeProfilePictureUrl(userInfo.profilePictureUrl, userInfo.givenName))"
           [src]="getSafeProfilePictureUrl(userInfo.profilePictureUrl, userInfo.givenName)"
           (error)="onImageError($event, userInfo.profilePictureUrl, userInfo.givenName)"
           alt="Profile picture"
           height="28"
           width="28"
           class="rounded-avatar"
           referrerpolicy="no-referrer"/>
      <!-- Menu dots icon (inline SVG for consistency) -->
      <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"/>
      </svg>
    </div>
    <!-- FIN-0106: Dropdown with soft rectangle (card) styling -->
    <div id="login_menu_dropdown" *ngIf="isLoginDropdownVisible"
         class="absolute right-0 top-full mt-1 w-64 bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-card shadow-elevated dark:shadow-gray-950/50 py-2 z-50 animate-message-in">
      <!-- Logout button - modernized -->
      <button type="button"
              class="w-full px-3 py-2 text-left text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2"
              (click)="logout()">
        <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
        </svg>
        <span>Log out</span>
      </button>

      <!-- Divider -->
      <div class="border-t border-gray-100 dark:border-gray-700 my-1"></div>

      <!-- Debug Tools Section - Collapsible for cleaner look -->
      <div class="px-3 py-2">
        <p class="text-xs text-gray-400 dark:text-gray-500 font-medium mb-2 uppercase tracking-wide">Developer</p>

        <!-- Worker Dashboard Button -->
        <button
          type="button"
          (click)="toggleWorkerDashboard(); $event.stopPropagation()"
          class="w-full text-left px-2 py-1.5 rounded-lg text-sm text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2"
          title="Show Worker Dashboard (WebSocket & Queue status)">
          <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
          </svg>
          <span>Worker Dashboard</span>
        </button>

        <!-- Trace UI Toggle -->
        <button
          type="button"
          (click)="toggleTraceUI(); $event.stopPropagation()"
          class="w-full text-left px-2 py-1.5 rounded-lg text-sm hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2"
          [class.text-brand-700]="isTraceUIEnabled()"
          [class.dark:text-brand-400]="isTraceUIEnabled()"
          [class.text-gray-600]="!isTraceUIEnabled()"
          [class.dark:text-gray-400]="!isTraceUIEnabled()"
          [title]="isTraceUIEnabled() ? 'Hide trace/progress UI' : 'Show trace/progress UI'">
          <svg class="w-4 h-4" [class.text-brand]="isTraceUIEnabled()" [class.text-gray-400]="!isTraceUIEnabled()" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
          </svg>
          <span>{{ isTraceUIEnabled() ? 'Trace UI ON' : 'Trace UI OFF' }}</span>
        </button>

        <!-- Record Logs Toggle -->
        <button
          type="button"
          (click)="toggleRecording(); $event.stopPropagation()"
          class="w-full text-left px-2 py-1.5 rounded-lg text-sm hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2"
          [class.text-red-600]="isRecordingEnabled()"
          [class.dark:text-red-400]="isRecordingEnabled()"
          [class.text-gray-600]="!isRecordingEnabled()"
          [class.dark:text-gray-400]="!isRecordingEnabled()"
          [title]="isRecordingEnabled() ? 'Stop recording' : 'Start recording'">
          <div class="w-4 h-4 flex items-center justify-center">
            <div class="w-2 h-2 rounded-full" [class.bg-red-500]="isRecordingEnabled()" [class.bg-gray-400]="!isRecordingEnabled()"></div>
          </div>
          <span>{{ isRecordingEnabled() ? 'Recording...' : 'Record Logs' }}</span>
        </button>

        <!-- Copy logs section - only show when recording -->
        <div *ngIf="isRecordingEnabled()" class="mt-2 pt-2 border-t border-gray-100 dark:border-gray-700 space-y-1">
          <button type="button" (click)="copyAllConsoleLogs(); $event.stopPropagation()"
                  class="w-full text-left px-2 py-1 rounded text-xs text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/></svg>
            All Logs
          </button>
          <button type="button" (click)="copyWebSocketLogs(); $event.stopPropagation()"
                  class="w-full text-left px-2 py-1 rounded text-xs text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
            WebSocket Logs
          </button>
          <button type="button" (click)="copyRecentErrors(); $event.stopPropagation()"
                  class="w-full text-left px-2 py-1 rounded text-xs text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
            Recent Errors
          </button>
          <button type="button" (click)="copyLastMinuteLogs(); $event.stopPropagation()"
                  class="w-full text-left px-2 py-1 rounded text-xs text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
            Last 60s
          </button>
          <button type="button" (click)="clearConsoleLogs(); $event.stopPropagation()"
                  class="w-full text-left px-2 py-1 rounded text-xs text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
            Clear
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Worker Dashboard (overlay) -->
  <app-worker-dashboard
    [(visible)]="showWorkerDashboard">
  </app-worker-dashboard>
</div>
